/** Default max height for pill-style chat composers (~8–10 lines). */
export const CHAT_COMPOSER_MAX_HEIGHT_PX = 200;
/** Single-line minimum for pill-style chat composers. */
export const CHAT_COMPOSER_MIN_HEIGHT_PX = 40;

/**
 * Grow a textarea to fit its content up to `maxHeightPx`, then scroll.
 * Returns the applied height so callers can restyle the shell when multiline.
 */
export function resizeComposerTextarea(
  textarea: HTMLTextAreaElement,
  minHeightPx: number,
  maxHeightPx: number,
): number {
  textarea.style.height = "0px";
  const nextHeight = Math.max(
    minHeightPx,
    Math.min(textarea.scrollHeight, maxHeightPx),
  );
  textarea.style.height = `${nextHeight}px`;
  textarea.style.overflowY =
    textarea.scrollHeight > maxHeightPx ? "auto" : "hidden";
  return nextHeight;
}
